import { useQuery, useMutation } from '@tanstack/react-query';

import { getCurrentUser, patchTogglePremierUserBanner } from '@src/requests/users';

const useCurrentUserQuery = (opts = {}) => {
    return useQuery({
        queryKey: ['current-user'],
        queryFn: getCurrentUser,
        staleTime: Infinity,
        ...opts,
    });
};

const useTogglePremierUserBanner = (opts = {}) => {
    return useMutation({
        mutationFn: patchTogglePremierUserBanner,
        ...opts,
    });
};

export { useCurrentUserQuery, useTogglePremierUserBanner };
